import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row } from "react-bootstrap";
import _ from "lodash";
import ApiUserTransaction from "../../../core/api/api.userTransaction";
export const ViewModal = ({ showModalUserTransaction, setShowModalUserTransaction, selectedUserTransaction }) => {
  const handleClose = () => {
    setShowModalUserTransaction(false);
  };
  const [itam, setUserTransaction] = useState();
  const checkAndShowItem = (item) => {
    if (item) return item;
    else return "---";
  };

  useEffect(() => {
    (async () => {
      try {
        if (selectedUserTransaction > 0) {
          // دریافت اطلاعات کاربر جهت ویرایش

          let response = await ApiUserTransaction.getUserTransactionById(selectedUserTransaction);
          if (response.succeeded == true) {
            setUserTransaction(response.data);
            //setValue("roleList", response.data.roleList);
          }
        }
      } catch (error) {
      }
    })();

    return () => { };
  }, []);

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="lg" onHide={handleClose} show={showModalUserTransaction}>
        <Modal.Header closeButton>
          <Modal.Title>اطلاعات تراکنش </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="border-bottom mb-3 mt-5">
            <h4>اطلاعات فردی</h4>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted"> نام و نام خانوادگی </div>
              <div className="mt-2"> {checkAndShowItem(itam?.userFullName)}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted"> شماره همراه </div>
              <div className="mt-2"> {checkAndShowItem(itam?.phoneNumber)}</div>
            </Col>
          </Row>
          <Row className="border-bottom mb-3 mt-5">
            <h4>اطلاعات تراکنش</h4>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted"> شماره تراکنش </div>
              <div className="mt-2"> {itam?.id ? itam.id : "---"}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted"> مبلغ </div>
              <div className="mt-2"> {itam?.amount ? itam.amount.toLocaleString() : "---"}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted"> وضعیت </div>
              <div className="mt-2"> {itam?.balanceType == 1 ? "افزایش موجودی" : "کاهش موجودی"}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted"> تاریخ انجام </div>
              <div className="mt-2"> {checkAndShowItem(itam?.completionDate)}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted"> زمان انجام </div>
              <div className="mt-2"> {checkAndShowItem(itam?.completionTime)}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted"> کد پیگیری </div>
              <div className="mt-2"> {checkAndShowItem(itam?.trackingCode)}</div>
            </Col>
            {itam?.description && (
              <Col xs="6" sm="4" lg className="mt-2 mb-5">
                <div className="fw-bold text-muted">توضیحات </div>
                <div className="mt-2" style={{ wordBreak: "break-all" }}>
                  {itam?.description}
                </div>
              </Col>
            )}
          </Row>
          {itam?.userPayment ? (
            <Row className="border-bottom mb-3 mt-5">
              <h4>اطلاعات پرداخت</h4>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> شماره پرداخت </div>
                <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.id)}</div>
              </Col>
              {itam.riallBalance !== itam.userPayment.rialAmount && (
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> مبلغ </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.rialAmount.toLocaleString())}</div>
                </Col>
              )}
              {itam.completionDate !== itam.userPayment.paymentDate && (
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> تاریخ انجام </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.paymentDate)}</div>
                </Col>
              )}
              {itam.completionTime !== itam.userPayment.paymentTime && (
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> زمان انجام </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.paymentTime)}</div>
                </Col>
              )}
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> شماره کارت پرداخت </div>
                <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.cardNumberPayment)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> شماره مرجع (referenceId) </div>
                <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.referenceId)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> شماره توکن </div>
                <div className="mt-2" style={{ wordBreak: "break-all" }}>
                  {checkAndShowItem(itam?.userPayment?.tokenNumber)}
                </div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> شماره ای پی </div>
                <div className="mt-2" style={{ wordBreak: "break-all" }}>
                  {checkAndShowItem(itam?.userPayment?.userIp)}
                </div>
              </Col>
              {itam.description !== itam.userPayment.description && (
                <Col xs="6" sm="4" lg className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> توضیحات </div>
                  <div className="mt-2" style={{ wordBreak: "break-all" }}>
                    {itam?.userPayment?.description}
                  </div>
                </Col>
              )}
            </Row>
          ) : (
            <></>
          )}
          {itam?.basket && (
            <Row className="border-bottom mb-3 mt-5">
              <h4>اطلاعات سبد خرید</h4>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> شماره سبد </div>
                <div className="mt-2">{checkAndShowItem(itam?.basket?.id)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> مبلغ اصلی </div>
                <div className="mt-2"> {checkAndShowItem(itam?.basket?.originalPrice.toLocaleString())}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> مبلغ نهایی </div>
                <div className="mt-2"> {checkAndShowItem(itam?.basket?.price.toLocaleString())}</div>
              </Col>
              {/* <Col xs="auto">
                                    وضعیت سبد  : {itam?.basket?.status}
                                </Col> */}
            </Row>
          )}
          {itam?.userWithdrawal && (
            <>
              <Row className="border-bottom mb-3 mt-5">
                <h4>اطلاعات درخواست برداشت وجه</h4>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره درخواست </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userWithdrawal?.id)}</div>
                </Col>
                {itam.riallBalance !== itam.userWithdrawal.rialAmount && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> مبلغ </div>
                    <div className="mt-2"> {checkAndShowItem(itam?.userWithdrawal?.rialAmount.toLocaleString())}</div>
                  </Col>
                )}
                {itam.completionDate !== itam.userWithdrawal.paymentDate && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> تاریخ انجام </div>
                    <div className="mt-2"> {checkAndShowItem(itam?.userWithdrawal?.paymentDate)}</div>
                  </Col>
                )}
                {itam.completionTime !== itam.userWithdrawal.paymentTime && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> زمان انجام </div>
                    <div className="mt-2"> {checkAndShowItem(itam?.userWithdrawal?.paymentTime)}</div>
                  </Col>
                )}
              </Row>
              <Row>
                {itam.userWithdrawal.destinationAccount && (
                  <Row className="border-bottom mb-3 mt-5">
                    <h4>اطلاعات حساب مقصد </h4>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> نام بانک </div>
                      <div className="mt-2"> {checkAndShowItem(itam.userWithdrawal.destinationAccount.bank)}</div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> نام صاحب حساب </div>
                      <div className="mt-2">
                        {checkAndShowItem(itam.userWithdrawal.destinationAccount.accountOwnerName)}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> شماره حساب </div>
                      <div className="mt-2">
                        {checkAndShowItem(itam.userWithdrawal.destinationAccount.accountNumber)}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> نام صاحب کارت </div>
                      <div className="mt-2">
                        {checkAndShowItem(itam.userWithdrawal.destinationAccount.cardOwnerName)}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> شماره کارت </div>
                      <div className="mt-2"> {checkAndShowItem(itam.userWithdrawal.destinationAccount.cardNumber)}</div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> شماره شبا </div>
                      <div className="mt-2">{checkAndShowItem(itam.userWithdrawal.destinationAccount.shebaNumber)}</div>
                    </Col>
                  </Row>
                )}
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon /> بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
